import { Theme } from '@material-ui/core'

const profileStyles = ({ breakpoints }: Theme) => ({
  root: {
    backgroundColor: '#fafafa'
  },
  container: {
    width: '100%'
  },
  logoutButton: {
    marginTop: '1rem',
    color: '#000000',
    border: '1px solid #C4C4C4',
    padding: '7px',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
      backgroundColor: '#F2F2F2',
      border: '1px solid #C4C4C4'
    }
  },
  imageContainer: {
    width: '100%',
    height: '50%',
    alignItems: 'flex-start',
    [breakpoints.down('sm')]: {
      display: 'none'
    },
    [breakpoints.up('md')]: {
      display: 'inline-flex'
    },
    [breakpoints.up('lg')]: {}
  },
  image: {
    width: 'fit-content'
  },
  formPaper: {
    marginTop: '2rem',
    display: 'flex',
    flexDirection: 'column' as const,
    minWidth: '85%',
    padding: '35px 50px 35px 50px',
    boxSizing: 'border-box' as const,
    [breakpoints.down('md')]: {
      padding: '35px 25px 45px 25px'
    },
    [breakpoints.down('sm')]: {
      padding: '15px 20px 15px 20px',
      width: '100%'
    }
  },
  form: {
    display: 'flex',
    maxWidth: '650px',
    maxHeight: '1200px',
    [breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '4rem'
    },
    [breakpoints.up('xl')]: {
      display: 'flex',
      maxWidth: '1000px'
    }
  },
  largeForm: {
    padding: '35px 50px 35px 50px',
    display: 'flex',
    maxWidth: '950px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [breakpoints.down('sm')]: {
      padding: '0px 5px'
    },
    [breakpoints.up('lg')]: {
      display: 'flex',
      maxWidth: '950px'
    }
  },
  greetings: {
    textAlign: 'start' as const,
    marginTop: '2rem',
    marginLeft: '2rem',
    [breakpoints.down('sm')]: {
      textAlign: 'center' as const,
      marginLeft: '0'
    }
  },
  loggedInStatus: {
    textAlign: 'start' as const,
    marginBottom: '2rem',
    marginLeft: '2rem',
    [breakpoints.down('sm')]: {
      marginLeft: '0',
      textAlign: 'center' as const
    }
  },
  changePassTitle: {
    textAlign: 'start' as const,
    marginTop: '2rem'
  },
  editTitle: {
    textAlign: 'start' as const
  }
})

export { profileStyles }
